import { ElementRef, ViewChild,Component, HostListener, Inject, OnInit } from "@angular/core";
import { DOCUMENT } from '@angular/platform-browser';
import { WINDOW } from "../../providers/window-providers.service";

@Component({
  selector: 'app-header-component',
  templateUrl: 'header-component.component.html',
  styleUrls: ['header-component.component.scss']
})
export class HeaderComponentComponent implements OnInit {

  public navIsFixed: boolean = false;
  @ViewChild('panel') public panel:ElementRef;

  constructor(@Inject(DOCUMENT) private document: Document, @Inject(WINDOW) private window) {

  }

  ngOnInit() { }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    let number = this.window.pageYOffset || this.document.documentElement.scrollTop || this.document.body.scrollTop || 0;
    if (number >= 600) {
      this.navIsFixed = true;
    } else {
      this.navIsFixed = false;
    }
  }

  scrollAt() {
    this.window.scrollTo(0,800);
  }
}



// WEBPACK FOOTER //
// ./src/components/header-component/header-component.component.ts